import React from 'react'
import { FullPageLayout } from '../../../components/FullPageLayout'
import { Link } from 'react-router-dom'
import routes from '../../../helpers/routes'
import { axiosInstance } from '../../../utils/axios'
import styled from 'styled-components'
import HeaderSection from '../components/HeaderSection'
import { Button } from 'react-bootstrap'
import { formatAmount, formatMoney } from '../../../utils/functions'

function useRecipes() {
  const [recipes, setRecipes] = React.useState<any>([])
  const [recipeCosts, setRecipeCosts] = React.useState<any>([])
  const [loading, setLoading] = React.useState<boolean>(true)

  React.useEffect(() => {
    // fetch
    (async () => {
      try {
        const response = await axiosInstance('/recipes/get-recipes')
        const data = await response.data;
        setRecipes(data)
        setLoading(false)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [])

  const fetchRecipeCosts = async () => {
    try {
      const response = await axiosInstance('/recipes/report/recipe-costs')
      const data = await response.data;
      setRecipeCosts(data)
    } catch (error) {
      console.error(error)
    }
  }

  const getRecipeCost = (recipeId: number) => {
    return recipeCosts.find((cost: any) => cost.recipeId === recipeId)?.totalCost || 'N/A'
  }

  const getRecipeAmount = (recipeId: number) => {
    return recipeCosts.find((cost: any) => cost.recipeId === recipeId)?.amount || 'N/A'
  }


  return { recipes, loading, fetchRecipeCosts, recipeCosts, getRecipeCost, getRecipeAmount }

}

export default function RecipesPage() {
  const { recipes, loading, fetchRecipeCosts, recipeCosts, getRecipeCost, getRecipeAmount } = useRecipes()
  return (
    <FullPageLayout>
      <Container>
        <HeaderSection title="Recetas" to={routes.recipes.newRecipe} linkString='Nueva Receta' />
        <Button variant='secondary' onClick={fetchRecipeCosts}>Obtener costo de recetas</Button>
        {loading && <p>Cargando...</p>}
        {recipes.map((recipe: any) => (
          <Recipe key={recipe.id}>
            <h5>{recipe.name}</h5>
            {recipeCosts.length > 0 &&
              <Costo>
                <div>Costo:</div>
                <div>
                  {formatMoney(formatAmount(getRecipeCost(recipe.id)))} / {formatAmount(getRecipeAmount(recipe.id))} Kg
                </div>
              </Costo>
            }
            <Link className="btn btn-sm btn-warning" to={routes.recipes.viewRecipe(recipe.id)}>Ver Receta</Link>
          </Recipe>
        ))}
      </Container>
    </FullPageLayout>
  )
}

export const Container = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: fit-content;
`
const Recipe = styled.div`
  border: 1px solid #ccc;
  padding: .8rem;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Costo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  @media (max-width: 768px) {
    align-items: flex-start;
  }
`